import { render, staticRenderFns } from "./AdditionalOption.vue?vue&type=template&id=6e8904d8&scoped=true&"
import script from "./AdditionalOption.vue?vue&type=script&lang=js&"
export * from "./AdditionalOption.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalOption.vue?vue&type=style&index=0&id=6e8904d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8904d8",
  null
  
)

export default component.exports